import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { Subject, takeUntil } from 'rxjs';
import { FuseConfirmationService } from '../../../../@fuse/services/confirmation';
import { LABELS } from '../../../core/constants/label-constants';
import { HelperService } from '../../../core/services/helper/helper.service';
import { CommonConstants } from '../../../core/constants/common-constants';
import { environment } from 'environments/environment.prod';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    standalone: true,
    imports: [
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        NgClass,
        MatDividerModule,
    ],
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: any;
    isPartner: boolean = false;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        public _router: Router,
        private _userService: UserService,
        private _fuseConfirmationService: FuseConfirmationService,
        public _helper: HelperService,
        private _cdr: ChangeDetectorRef,
    ) {
        this.isPartner = ((this._router.url.indexOf('/partner') !== -1 || window.location.origin.indexOf('partners') !== -1)); 
        if(this._router.url.indexOf('/partner-management') != -1){
            this.isPartner = false
        }
        this._helper.userData.subscribe((res: any) => {
            if(res){
                this.user = res;
                this._cdr.detectChanges()
            }
        })
        this.getUserData()
    }

    getUserData(){
        let user: any;
        if( this.isPartner){
            user = this._helper.getLocalStorageData(CommonConstants.PARTNER_DATA)
        } else {

            user = this._helper.getLocalStorageData(CommonConstants.USER_DATA)
        }
        if(user){
            this.user = user;
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }

        // Update the user
        this._userService
            .update({
                ...this.user,
                status,
            })
            .subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void {
        const confirmation = this._fuseConfirmationService.open({
            title: 'Sign out',
            message: 'Are you sure you want to sign out?',
            actions: {
                confirm: {
                    label: 'Sign out',
                },
            },
        });
        confirmation.afterClosed().subscribe((result) => {
            if (result === 'confirmed') {
                if( this._router.url.indexOf('/partner') !== -1 || window.location.origin.indexOf('partners') !== -1){
                     environment.production ? this._router.navigate(['sign-out']) : this._router.navigate(['/partner/sign-out']);
                } else {
                    this._router.navigate(['/sign-out']);
                }
            } else {

            }
        })

        /*let token: any;
        token = this._helper.getLocalStorageData(CommonConstants.TOKEN);
        if(token){
            this._authService.logout().subscribe((res:any) => {
                if (res?.meta?.status === 1){
                    this._helper.removeLocalStorageData(CommonConstants.TOKEN);
                    this._helper.removeLocalStorageData(CommonConstants.ADMIN_CHECK_URL);
                    this._helper.removeLocalStorageData(CommonConstants.SUB_ADMIN_CHECK_URL);
                    this._helper.removeLocalStorageData(CommonConstants.CLIENT_TOKEN);
                    this._helper.removeLocalStorageData(CommonConstants.CLIENT_CHECK_URL);
                    this._helper.removeLocalStorageAllData();
                    this._router.navigateByUrl('sign-in');
                } else {
                    this._router.navigateByUrl('sign-in');
                }
            })
        } else {
            this._router.navigateByUrl('sign-in');
        }*/
    }

    /**
     * Summary: Redirect admin / client on setting page
     */
    redirectToSetting(){
        if(this.isPartner){
            environment.production ? this._router.navigate(['my-profile']): this._router.navigate(['partner/my-profile']);
        } else {
            this._router.navigate(['/my-profile']);
        }
    }

     /**
     * Summary: Redirect to change password page
     */
    redirectToChangePassword(){
        if(this.isPartner){
            environment.production ? this._router.navigate(['change-password']): this._router.navigate(['partner/change-password']);
        } else {
            this._router.navigate(['/change-password']);
        }
    }


    protected readonly LABELS = LABELS;
}
